import { render } from "./TabWithTable.vue?vue&type=template&id=04f43d5b&scoped=true"
import script from "./TabWithTable.vue?vue&type=script&lang=js"
export * from "./TabWithTable.vue?vue&type=script&lang=js"

import "./TabWithTable.vue?vue&type=style&index=0&id=04f43d5b&lang=scss&scoped=true"

import exportComponent from "../../../../../CASRA/saoil/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04f43d5b"]])

export default __exports__